export default Object.freeze({
	RECURRING_PAYMENTS_PRODUCT_MANAGEMENT: '정기결제(배송) 상품 관리',

	SEARCH_RESULT_COUNT: '검색결과 총 {count}건',
	REGISTER_RECURRING_PAYMENTS_PRODUCT: '정기결제(배송) 상품 등록',
	CHANGE_PRODUCTS_SETTING: '상품 설정 일괄 변경',
	PLEASE_SELECT_PRODUCT_TO_CHANGE_SETTING: '설정을 변경할 상품을 선택해주세요.',

	DESCRIPTION_1: '정기결제(배송) 가능한 상품의 최소 금액은 500원 입니다.',

	DESCRIPTION_ABOUT_TERMS: '정기결제(배송) 사용 시 반드시 주문서 페이지에 이용약관을 설정하시기 바랍니다.',
	GO_TO_TERMS_OF_USE: '이용약관 바로가기>',

	PARTNERS: '파트너사',
	SALE_STATUS: '판매상태',
	SALE_SETTING_STATUS: '판매설정',
	DELIVERY_CYCLE: '배송주기',
	PRODUCT_STATUS: '상품상태',
	DISPLAY_STATUS: '전시상태',

	// 검색어
	PARTNERS_PLACEHOLDER: '파트너명 입력',
	PLEASE_SELECT_SHOP: '쇼핑몰을 먼저 선택해주세요',
	SEARCHING_FOR_MULTIPLE_PRODUCTS_IS_POSSIBLE_BY_ENTER_OR_COMMA: '복수 상품 검색이 가능합니다. (Enter 또는 \',\'로 구분)',
	NO_SEARCHED_RESULT: '검색결과가 없습니다.',

	PRODUCT_NAME: '상품명',
	PRODUCT_NO: '상품번호',

	WAITING_SALE: '판매대기',
	ON_PRE_SALE: '예약판매중',
	ON_SALE: '판매중',
	END_SALE: '판매종료',
	STOP_SELLING: '판매중지',
	PROHIBITION_SALE: '판매금지',


	ONE_MONTH: '1개월',
	TWO_MONTH: '2개월',
	THREE_MONTH: '3개월',
	FOUR_MONTH: '4개월',
	FIVE_MONTH: '5개월',
	SIX_MONTH: '6개월',

	// 상품 상태
	APPROVAL_STATUS: '승인상태',
	WAITING_REGISTRATION: '등록대기',
	WAITING_APPROVAL_AFTER_MODIFY: '수정 후 승인대기',
	APPROVAL_REJECTION_AFTER_MODIFY: '수정 후 승인거부',

	// 전시 상태
	DISPLAY_POSSIBLE: '전시 가능',
	NOT_DISPLAY: '전시 안함',

	// 그리드
	SELLING_PRICE: '판매가',
	DISCOUNT_ON_RECURRING_PAYMENTS_IMMEDIATELY: '정기결제(배송)\n즉시할인',
	DISCOUNT_PRICE: '할인 적용가',
	REGISTRANT_NAME: '등록자',
	PERSON_WHO_LAST_UPDATED: '최종수정자',
	LAST_UPDATE_DATE: '최종수정일',

	// 승인 상태 response
	REGISTRATION_READY: '등록대기',
	APPROVAL_READY: '승인대기',
	APPROVAL_REJECTION: '승인거부',
	SALE_AGREEMENT_READY: '판매합의대기',
	SALE_AGREEMENT_REJECTION: '판매합의거부',
	FINISHED: '승인완료',
	AFTER_APPROVAL_READY: '수정 후 승인대기',
	AFTER_APPROVAL_REJECTION: '수정 후 승인거부',

	// 정기결제(배송) 상품 설정 일괄변경 팝업 관련
	CHANGING_RECURRING_PAYMENTS_PRODUCT_SETTING: '정기결제(배송) 상품 설정 일괄변경',
	SETTING_DESCRIPTION_1: '선택하신 {selectedProductsCount}건 상품의 ' +
		'배송 주기 및 상품할인 설정이 일괄 업데이트 됩니다.',
	SETTING_DESCRIPTION_2: '업데이트 시 기존 정기결제(배송) 신청 내역에는 반영되지 않습니다.',
	ONLY_UNITS_OF_10: '가격은 10원 단위로 입력 가능합니다.',
	ONLY_BETWEEN_0_AND_99: '0 ~ 99 사이로 입력해주세요.',
	PLEASE_CHECK_INPUT: '입력 항목을 확인해주세요.',
	PLEASE_SELECT_DELIVERY_CYCLE: '배송 주기를 선택해주세요.',

	BASIC_INFORMATION: '기본정보',
	PRODUCT_DISCOUNT_SETTING: '상품할인 설정',
	PRODUCT_DISCOUNT: '상품할인',
	DISCOUNT_IMMEDIATELY: '즉시할인',

	THERE_IS_PRODUCT_WITH_NEGATIVE_DISCOUNT_PRICE: '마이너스인 할인적용가 상품이 있습니다. 즉시할인가를 변경해주세요',

	// 상품 등록
	RECURRING_PAYMENTS_PRODUCT_REGISTER: '정기결제(배송) 상품 등록',
	RECURRING_PAYMENTS_PRODUCT_EDIT: '정기결제(배송) 상품 수정',
	REGISTER_DESCRIPTION_1: '정기결제(배송) 상품은 판매중, 전시가능, 쇼핑몰 배송, ' +
		'프론트 노출 설정이 된 상품과 배송 지정일을 설정하지 않은 상품만 가능합니다.',
	REGISTER_DESCRIPTION_2: '세트상품/예약상품은 정기결제(배송) 상품으로 등록이 불가합니다.',
	PRODUCTS_DISCOUNTED_IMMEDIATELY_COUNT: '즉시할인 대상 상품 {count}건',
	DELETE_SELECTED_PRODUCTS: '선택 상품 삭제',
	SEARCH_PRODUCT: '상품 조회',
	ADD_SUCCESS: '추가 되었습니다.\n성공 {successCount}건, 실패 {failureCount}건',
	PLEASE_SELECT_PRODUCTS_TO_DELETE: '삭제할 상품을 선택해주세요.',

	// 컨펌
	COMPLETE_REGISTRATION_CONFIRM_TEXT: '정기결제(배송) 상품 등록을 완료하시겠습니까?',
	DELETE_SELECTED_PRODUCTS_CONFIRM_TEXT: '선택하신 정기결제(배송) 상품을 목록에서 삭제하시겠습니까?',
	CHANGE_MALL_CONFIRM_TEXT: '쇼핑몰 변경 시 상품정보가 초기화됩니다.\n계속 진행하시겠습니까?',
	CHANGE_DISCOUNT_INFO_CONFIRM_TEXT: '즉시할인 등록 정보를 변경하시면 ' +
		'설정한 상품리스트가 초기화됩니다.\n계속 진행하시겠습니까?',
	CANCEL_REGISTRATION_CONFIRM_TEXT: '등록을 취소하고 목록으로 돌아가시겠습니까?\n입력하신 내용은 저장되지 않습니다.',
	DELETE_PRODUCT_CONFIRM_TEXT: '상품을 삭제하시면 ' +
		'해당 상품으로 정기결제(배송) 신청된 주문이 모두 해지처리됩니다. 해지 처리된 신청건은 신청내역 관리에서 확인 가능합니다.\n정말 삭제하시겠습니까?'
})